import {Injectable} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {BAD_REQUEST, FORBIDDEN, METHOD_NOT_ALLOWED, NOT_FOUND, UNAUTHORIZED} from 'http-status-codes';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {ErrorAlertService} from './error-alert.service';

@Injectable({
    providedIn: 'root'
})
export class ErrorLogService {

    constructor(private router: Router,
                private location: Location,
                private translate: TranslateService,
                private errorAlertService: ErrorAlertService) {
    }

    logError(error: any) {
        const httpErrorCode = error.status;
        if (error instanceof HttpErrorResponse) {
            console.error('There was an HTTP error.', error.message, 'Status code:', (<HttpErrorResponse>error).status);
        } else if (error instanceof TypeError) {
            console.error('There was a Type error.', error.message);
        } else if (error instanceof Error) {
            console.error('There was a general error.', error.message);
        } else {
            console.error('Error', error);
        }


        switch (httpErrorCode) {
            case 0:
                this.errorAlertService.setError('HTTP-ERROR.COULD-NOT-GET-RESPONSE');
                // this.errorAlertService.publish('error-alert');
                break;
            case 500:
                this.errorAlertService.setError('HTTP-ERROR.INTERNAL-ERROR');
                // this.errorAlertService.publish('error-alert');
                break;
            case METHOD_NOT_ALLOWED:
                this.errorAlertService.setError('HTTP-ERROR.UNAUTHORIZED-REQUEST');
                // this.errorAlertService.publish('error-alert');
                this.location.back();
                break;
            case UNAUTHORIZED:
                this.errorAlertService.setError('HTTP-ERROR.UNAUTHORIZED-REQUEST');
                // this.errorAlertService.publish('error-alert');
                this.router.navigate(['/', 'others', '403']);
                break;
            case FORBIDDEN:
                this.router.navigate(['/', 'others', '403']);
                break;
            case BAD_REQUEST:
                this.router.navigate(['/', 'others', '404']);
                break;
            case NOT_FOUND:
                this.router.navigate(['/', 'others', '404']);
                break;
            default:
                this.router.navigate(['/', 'others', '404']);
        }
    }
}
